export const SET_SELECTED_CODE = 'SET_SELECTED_CODE'
export const CODES_GET_ALL = 'CODES_GET_ALL'
export const CODES_GET_CUSTOMER = 'CODES_GET_CUSTOMER'
export const CODE_TYPES_GET_ALL = 'CODE_TYPES_GET_ALL'
export const SAVE_CODE = 'SAVE_CODE'




// WEBPACK FOOTER //
// ./src/store/modules/callcodes/mutation-types.js